// import React from 'react'
import withView from '../../../../cmn/docAutomation/withView';
// import FormLabel from '../../../../../library/form/components/FormLabel';
// import FormROValue from '../../../../../library/form/components/FormROValue1';
// import FormInput from '../../../../../library/form/components/FormInput';
// import { UiView, UiViewContent, UiGridColTwo, UiCol } from "../../../../../library/layout/Index";

//most code comment because main return value is commented

const ProdAction = (props) => {
    // const { formObject } = props;

    return null;

    //TODO complete the code of fingerprint before rendering this
    // return (
    //     <UiView>
    //         <UiViewContent>
    //             <UiGridColTwo>
    //                 <UiCol>
    //                     <ul className="uiSpacer10">
    //                         <li>
    //                             <span className="uiLbl">
    //                                 <FormLabel formObject={formObject} rowKey="" action={{ paramName: "actionId" }} value="Action Id" />
    //                             </span>
    //                             <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "actionId" }} />
    //                         </li>
    //                         <li>
    //                             <span className="uiLbl">
    //                                 <FormLabel formObject={formObject} rowKey="" action={{ paramName: "auditedOn" }} value="Audited On" />
    //                             </span>
    //                             <FormInput formObject={formObject} rowKey="" className="uiInput"
    //                                 action={{ InputType: "dp", paramName: "auditedOn" }} />
    //                         </li>
    //                     </ul>
    //                 </UiCol>
    //             </UiGridColTwo>

    //         </UiViewContent>
    //     </UiView>
    // )
}

export default withView(ProdAction, "prodComp", "");